var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"key-value-data"},[_c('div',{staticClass:"text-14px"},[_vm._v(_vm._s(_vm.item.key))]),(_vm.item.component)?_c(_vm.item.component,_vm._b({tag:"component"},'component',_vm.item.componentProps,false)):_c('div',{staticClass:"text-14px dark"},[_vm._v(_vm._s(_vm.item.value))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }